export default __webpack_public_path__ + "static/green-school_1-1fe4ae8c2808f17a6258f48bc6a8aecd.png";